

interface ValidationResult {
    valid: boolean,
    message: string|JSX.Element
}
export type Validator = (value: string) => Promise<ValidationResult>

export const validatePresence = (messageOverride?: string|JSX.Element) : Validator => {
    return (value) => {
        return new Promise ((resolve, reject) => {
            const result : ValidationResult = {
                valid: (value.length > 0),
                message: messageOverride || "Required Input",
            }
    
            resolve(result)
        })
    }
}

export const validatePassword = (messageOverride?: string|JSX.Element) : Validator => {
    return (value) => {
        return new Promise ((resolve, reject) => {
            const result : ValidationResult = {
                valid: (value.length >= 8),
                message: messageOverride || "Password to short (min 8)",
            }
    
            resolve(result)
        })
    }
}

export const validateEmailIsUnused = (
    emailLookupFn: (value: string) => Promise<boolean>, 
    messageOverride?: string|JSX.Element
) : Validator => {
    return (value) => {
        return new Promise (async (resolve, reject) => {
            const result : ValidationResult = {
                valid: await emailLookupFn(value),
                message: messageOverride || "Email already used",
            }
    
            resolve(result)
        })
    }
}
export const validateEmail = (messageOverride?: string|JSX.Element) : Validator => {
    return (value) => {
        return new Promise ((resolve, reject) => {
            const validateDomain = (domain: string): boolean => {
                return (
                    domain.length > 0 &&
                    domain.length <= 253 &&
                    !/[^a-zA-Z0-9]/.test(domain.slice(-2)) &&
                    !/[^a-zA-Z0-9]/.test(domain.substr(0, 1)) &&
                    !/[^a-zA-Z0-9\.\-]/.test(domain) &&
                    domain.split("..").length === 1 &&
                    domain.split(".").length > 1
                )
            }
            
            const validateEmailParts = (localPart: string, domain: string): boolean => {
                if (localPart && domain) {
                    if (localPart.indexOf('"') === 0) {
                        const len = localPart.length
                        localPart = localPart.replace(/\"/g, "")
                        if (localPart.length !== len - 2) {
                            return false
                        }
                    }
                    return (
                        validateDomain(domain) &&
                        localPart.indexOf(".") !== 0 &&
                        localPart.substring(localPart.length - 1, localPart.length) !== "." &&
                        localPart.indexOf("..") === -1 &&
                        !/[^\w\+\.\-\#\-\_\~\!\$\&\'\(\)\*\+\,\;\=\:]/.test(localPart)
                    )
                }
                return false
            }

            const [localPart, domain] = value.toLowerCase().split("@")
            const result : ValidationResult = {
                valid: validateEmailParts(localPart, domain),
                message: messageOverride || "Invalid email",
            }
    
            resolve(result)
        })
    }
}